export class DeliveryMethodType {
  public static readonly OMNIVA = 'omniva';
  public static readonly DPD = 'dpd';
  public static readonly SMARTPOST = 'smartpost';
  public static readonly PAXI = 'paxi';
  public static readonly PUDO = 'pudo';
  public static readonly POSTNET = 'postnet';
  public static readonly ARAMEX = 'aramex';
  public static readonly DELHIVERY = 'delhivery';
  public static readonly FARGO = 'fargo';
  public static readonly PARGO = 'pargo';
  public static readonly MTAANI = 'mtaani';
  public static readonly BUNDLING = 'bundling';

  public static readonly EEShippingMethods = [DeliveryMethodType.DPD, DeliveryMethodType.OMNIVA, DeliveryMethodType.SMARTPOST];
  public static readonly SAShippingMethods = [
    DeliveryMethodType.PAXI,
    DeliveryMethodType.PUDO,
    DeliveryMethodType.PARGO,
    DeliveryMethodType.POSTNET,
    DeliveryMethodType.ARAMEX,
  ];
  public static readonly INShippingMethods = [DeliveryMethodType.DELHIVERY];
  public static readonly KEShippingMethods = [DeliveryMethodType.FARGO, DeliveryMethodType.MTAANI];

  /**
   * Fetch more details for these shipping options
   */
  public static readonly withDetails = [
    DeliveryMethodType.DPD,
    DeliveryMethodType.OMNIVA,
    DeliveryMethodType.SMARTPOST,
    DeliveryMethodType.PUDO,
    DeliveryMethodType.POSTNET,
  ];
}
